/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerLeftDownIcon32Regular = forwardRef('ArrowDCornerLeftDownIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M11 10a5 5 0 0 1 5-5h12a1 1 0 1 1 0 2H16a3 3 0 0 0-3 3v15.586l7.293-7.293a1 1 0 0 1 1.414 1.414l-7.338 7.338a3.35 3.35 0 0 1-4.738 0l-7.338-7.338a1 1 0 1 1 1.414-1.414L11 25.586V10Z" })));
});
